import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TUserPassport, TUserPassportPayload, TUserPassportResponse, adaptUserPassportFromResponse, adaptUserPassportToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_USERS } from '../../backend-paths';


export const userPassportUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_USERS}/:nickname/passport`,
	(payload: TUserPassportPayload, thunkApi) => {
		const { nickname, data, files = [] } = payload;

		const path = `${BACKEND_ADMIN_USERS}/${nickname}/passport`;

		const dataRequest = adaptUserPassportToRequest(data);

		return HttpService.put<TUserPassportResponse>(path, dataRequest).then(result => {
			const pathFiles = `${path}/files`;

			const filesDataRequest = { files };

			const config = {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			};

			return HttpService.put<TUserPassportResponse>(pathFiles, filesDataRequest, config).then(result => {
				return adaptUserPassportFromResponse(result.data);
			}).catch((error: HttpError) => {
				return thunkApi.rejectWithValue({ ...error });
			});
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TUserPassport> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userPassportUpdateSlice = createSlice({
	name: 'userPassportUpdateSlice',
	initialState,
	reducers: {
		clearUserPassportUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userPassportUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[userPassportUpdateApi.fulfilled.type]: (state, action: PayloadAction<TUserPassport>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userPassportUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useUserPassportUpdateSelector = () => useAppSelector(state => state[userPassportUpdateSlice.name]);

export const { clearUserPassportUpdate } = userPassportUpdateSlice.actions;
